export const totalLotsCalculation = arr => {
    let sum = 0;
    arr.map(item => {
        return (sum += Number(item?.shares_count) * Number(item?.price));
    });
    return sum;
};
